import { H5 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";

export const FulfillmentTypeStartingPrice = ({
  orderItemLength,
  fulfillmentTypeCharge,
  fulfillmentType,
  hasPerItemCharges,
}: {
  orderItemLength: number;
  fulfillmentTypeCharge: number | undefined | null;
  // currently "undefined" refers to "collection" OR no fulfillmentType passed, due to not existing in fulfillmentType table
  fulfillmentType:
    | "courier"
    | "haulier"
    | "direct"
    | "sellarDistribution"
    | undefined;
  hasPerItemCharges: boolean;
}) => {
  const hasChargesToApply = hasPerItemCharges || fulfillmentTypeCharge;
  if (!orderItemLength && fulfillmentType && hasChargesToApply) {
    if (fulfillmentTypeCharge) {
      return <H5>Starting from {formatCurrency(fulfillmentTypeCharge)}</H5>;
    }

    return <H5>£ Add items to see charges</H5>;
  }

  return <H5>FREE</H5>;
};
